import { topicsItems } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-600">大家都在关注什么？发现最热门的观影话题</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsItems.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#cards")?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? "bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600"
                  : "bg-background-50 text-foreground-700 border border-background-300/60 hover:border-primary-300 hover:text-primary-500"
              }`}
            >
              {topic.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs"></i>
                </span>
              )}
              <span>#{topic.label}</span>
              <span className={`text-xs ${topic.hot ? "text-background-50/70 dark:text-foreground-950/70" : "text-foreground-400"}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}